<template>
  <b-container>
    <h1>Teacher Institute Courses</h1>
    <div
      class="jumbotron"
      v-if="enabledStatus === false || enabledStatus === 'false'"
    >
      <p v-html="disabledText[0].disabledText"></p>
    </div>
    <div
      class="jumbotron"
      v-if="enabledStatus === true || enabledStatus === 'true'"
    >
      <p v-html="mainIntroductionText[0].mainIntroductionText"></p>
      <hr />
      <h2 id="cancellationPolicy">COURSE CANCELLATION POLICY</h2>
      <p v-html="cancellationPolicyText[0].cancellationPolicyText"></p>

      <hr />
      <h2>TUITION DISCOUNTS</h2>
      <p v-html="tuitionDiscountText[0].tuitionDiscountText"></p>
      <hr />
      <p>
        Choose your desired courses from the list below. Once you have made your
        selection(s), click on the Shopping Cart button to continue.
      </p>
      <div role="tablist">
        <div v-for="(crs, index) in allCourses.subjects" :key="index">
          <b-card no-body class="mx-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button
                block
                v-b-toggle="'accordian-' + index"
                variant="outline"
              >
                <span>
                  {{ crs.subjectDescription }} ({{ crs.courses.length }}) &nbsp;
                  <b-badge>
                    <b-icon-chevron-down font-scale="1"></b-icon-chevron-down>
                  </b-badge>
                </span>
              </b-button>
            </b-card-header>
            <b-collapse
              :id="'accordian-' + index"
              accordion="my-accordion"
              role="tabpanel"
            >
              <div v-for="(subjCrs, index) in crs.courses" :key="index">
                <div style v-show="crs.courses.length <= 4">
                  <b-row class="px-1">
                    <b-col sm="12" md="12" lg="12" class="d-block">
                      <p class="d-block"></p>
                      <h4>{{ subjCrs.title }}</h4>
                    </b-col>
                    <b-col sm="12" md="12" lg="6" class="d-block">
                      <p class="d-sm-line">
                        <b>Dates:</b>
                        {{ subjCrs.beginDate }} - {{ subjCrs.endDate }}
                      </p>
                    </b-col>
                    <b-col sm="12" md="12" lg="6" class="d-block">
                      <p>
                        <b
                          v-b-tooltip.hover
                          v-b-tooltip.html
                          title="<ul class='list-group text-left'><li>M - Monday</li><li>T - Tuesday</li><li>W - Wednesday</li><li>R - Thursday</li><li>F - Friday</li><li>S - Saturday</li><li>U - Sunday</li></ul>"
                        >
                          Meets
                          <b-icon-info></b-icon-info>:
                        </b>
                        {{ subjCrs.daysOfWeek }}
                      </p>
                    </b-col>
                    <b-col sm="12" md="12" lg="6" class="d-block">
                      <p>
                        <b>Credits:</b>
                        {{ subjCrs.creditHours }}
                      </p>
                    </b-col>
                    <b-col sm="12" md="12" lg="6" class="d-block">
                      <p>
                        <b>Seats Available:</b>
                        {{ subjCrs.seats }}
                      </p>
                    </b-col>
                    <b-col sm="12" md="12" lg="6" class="d-block">
                      <p>
                        <b>Cost:</b>
                        ${{ subjCrs.cost }}
                      </p>
                    </b-col>
                    <b-col sm="12" md="12" class="d-block">
                      <p>{{ subjCrs.description }}</p>
                    </b-col>
                  </b-row>
                  <b-button
                    variant="danger"
                    class="d-block ml-2 mb-2"
                    size="lg"
                    @click="addToCart(subjCrs.crn, subjCrs.term)"
                    v-if="subjCrs.seats > 0"
                    >Add to Cart</b-button
                  >
                </div>

                <b-card
                  no-body
                  class=""
                  sm="12"
                  v-show="crs.courses.length > 4"
                >
                  <b-card-header header-tag="header" class="mb-2">
                    <span v-b-toggle="'accordian-' + subjCrs.crn">
                      <b-badge>
                        <b-icon-chevron-down
                          font-scale="1"
                        ></b-icon-chevron-down>
                      </b-badge>
                      &nbsp;{{ subjCrs.title }} ({{ crs.subjectDescription }})
                    </span>
                  </b-card-header>
                  <b-collapse
                    :id="'accordian-' + subjCrs.crn"
                    accordion="smashed-accordion"
                    role="tabpanel"
                  >
                    <b-col sm="12" md="12" lg="6" class="d-block">
                      <p class="d-sm-line">
                        <b>Dates:</b>
                        {{ subjCrs.beginDate }} - {{ subjCrs.endDate }}
                      </p>
                    </b-col>
                    <b-col sm="12" md="12" lg="6" class="d-block">
                      <p>
                        <b
                          v-b-tooltip.hover
                          v-b-tooltip.html
                          title="<ul class='list-group text-left'><li>M - Monday</li><li>T - Tuesday</li><li>W - Wednesday</li><li>R - Thursday</li><li>F - Friday</li><li>S - Saturday</li><li>U - Sunday</li></ul>"
                        >
                          Meets
                          <b-icon-info></b-icon-info>:
                        </b>
                        {{ subjCrs.daysOfWeek }}
                      </p>
                    </b-col>
                    <b-col sm="12" md="12" lg="6" class="d-block">
                      <p>
                        <b>Credits:</b>
                        {{ subjCrs.creditHours }}
                      </p>
                    </b-col>
                    <b-col sm="12" md="12" lg="6" class="d-block">
                      <p>
                        <b>Seats Available:</b>
                        {{ subjCrs.seats }}
                      </p>
                    </b-col>
                    <b-col sm="12" md="12" lg="6" class="d-block">
                      <p>
                        <b>Cost:</b>
                        ${{ subjCrs.cost }}
                      </p>
                    </b-col>
                    <b-col sm="12" md="12" class="d-block">
                      <p>{{ subjCrs.description }}</p>
                    </b-col>
                    <b-button
                      variant="danger"
                      class="d-block ml-2 mb-2"
                      size="lg"
                      @click="addToCart(subjCrs.crn, subjCrs.term)"
                      v-if="subjCrs.seats > 0"
                      >Add to Cart</b-button
                    >
                  </b-collapse>
                </b-card>
              </div>
            </b-collapse>
          </b-card>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
import { mixins } from "../mixins";

export default {
  name: "home",
  data() {
    return {
      allCourses: [],
      mainIntroductionText: [],
      cancellationPolicyText: [],
      tuitionDiscountText: [],
      enabledStatus: null,
      disabledText: [],
    };
  },
  mixins: [mixins],
  created() {
    this.getEnabledStatus();
    this.getCourses();
    this.getIntro();
    this.getCancellationPolicy();
    this.getTuitionDiscount();
    this.getDisabledText();
  },
  methods: {
    getEnabledStatus() {
      this.api.get("/enabledStatus").then((res) => {
        this.enabledStatus = res.data;
      });
    },
    getIntro() {
      this.api
        .get("/mainIntroductionText")
        .then((res) => {
          this.mainIntroductionText = res.data;
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.mainIntroductionText = {
              title: "ERROR:",
            };
          } else {
            this.mainIntroductionText = {
              title: "ERROR:",
            };
          }
        });
    },
    getCancellationPolicy() {
      this.api
        .get("/cancellationPolicyText")
        .then((res) => {
          this.cancellationPolicyText = res.data;
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.cancellationPolicyText = {
              title: "ERROR:",
            };
          } else {
            this.cancellationPolicyText = {
              title: "ERROR:",
            };
          }
        });
    },
    getTuitionDiscount() {
      this.api
        .get("/tuitionDiscountText")
        .then((res) => {
          this.tuitionDiscountText = res.data;
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.tuitionDiscountText = {
              title: "ERROR:",
            };
          } else {
            this.tuitionDiscountText = {
              title: "ERROR:",
            };
          }
        });
    },
    getDisabledText() {
      this.api
        .get("/disabledText")
        .then((res) => {
          this.disabledText = res.data;
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.disabledText = {
              title: "ERROR:",
            };
          } else {
            this.disabledText = {
              title: "ERROR:",
            };
          }
        });
    },
    getCourses() {
      this.api
        .post("/offeredCourses", {
          cartId: this.$store.getters.cartId,
        })
        .then((response) => {
          this.allCourses = response.data;
        })
        .catch((error) => {
          this.errorToast(error.response.data.message || error.message || "");
        });
    },
    addToCart(crn, term) {
      this.api
        .post("addToCart", {
          term: term,
          crn: crn,
          cartId: this.$store.getters.cartId,
        })
        .then((response) => {
          this.$store.commit("setCartId", response.data.cartId);
          this.successToast("Added to Cart");
          this.getCourses();
        })
        .catch((error) => {
          this.errorToast(error.response.data.message || error.message || "");
        });
    },
  },
};
</script>

<style scoped></style>
